import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { QuotationFactory, ShipmentFactory } from '@library/common';
import { IGenericType } from '@library/common/generictype';
import { QuotationDetailsService } from '@library/modules/api-services';
import { ShipmentService } from '@library/modules/shipment';
import { ShipmentDetailsService } from '@library/modules/shipment-details';
import { TemplateService } from '@library/modules/templates';
// import { ShipmentDetailsService } from '@library/modules/shipment-details';

@Component({
  selector: 'app-quotation-select',
  templateUrl: './quotation-select.component.html',
  styleUrls: ['./quotation-select.component.scss']
})
export class QuotationSelectComponent implements OnInit {
  formGroup = new FormGroup({
    from: new FormControl( 'blank' ),
    templateId: new FormControl(),
    pastQuote: new FormGroup({
      mode: new FormControl('copy', [ Validators.required ]),
      number: new FormControl('', [ Validators.required ]),
    }),
    pastShip: new FormGroup({
      mode: new FormControl('copy', [ Validators.required ]),
      number: new FormControl('', [ Validators.required ]),
    }),
    shipment: new FormGroup({ }),
  });

  get from() { return this.formGroup.get('from') as FormGroup; }
  get templateId() { return this.formGroup.get( 'templateId' ) as FormGroup; }
  get shipment() { return this.formGroup.get( 'shipment' ) as FormGroup; }
  get pastShip() { return this.formGroup.get( 'pastShip' ) as FormGroup; }
  get pastQuote() { return this.formGroup.get( 'pastQuote' ) as FormGroup; }
  get pastShipHawb() { return this.pastShip.get( 'number' ) as FormGroup; }
  get pastQuoteNumber() { return this.pastQuote.get( 'number' ) as FormGroup; }

  loading = false;
  templateDesc = '';

  constructor(
    private router: Router,
    private shipmentService: ShipmentService,
    private shipDetailService: ShipmentDetailsService,
    private quoteDetailService: QuotationDetailsService,

    public templateService: TemplateService,
    // private shipmentService: ShipmentDetailsService,
  ) { }

  ngOnInit() {
  }

  next() {
    this.loading = true;

    switch( this.formGroup.get('from').value ) {
      case 'template':
        this.fromTemplate();
        break;

      case 'past-shipment':
        this.fromPastShipment();
        break;

      case 'past-quotation':
        this.fromPastQuotation();
        break;

      case 'blank':
        this.formGroup.reset({ from: 'blank' });
        this.shipmentService.reset();

      default:
        this.router.navigate([ '/create/quotation/new' ]);
    }
  }

  templateSelect( template: IGenericType ) {
    this.templateDesc = template.description ?? '';
  }

  private fromPastQuotation() {
    this.pastQuote.disable();

    if ( !this.pastQuote.get('number').value ) {
      this.loading = false;
      return;
    }

    this.pastQuote.get('number').setValue( this.pastQuote.get('number').value.trim() );
    this.pastQuote.get('mode').setValue( this.pastQuote.get('mode').value === 'copy' ? null : this.pastQuote.get('mode').value );

    this.quoteDetailService.load( this.pastQuote.get('number').value )
      .subscribe(( quotation ) => {
        if ( quotation ) {
          this.shipmentService.shipment = ShipmentFactory.copy( QuotationFactory.toShip( quotation ), this.pastQuote.get('mode').value );

          this.router.navigate([ '/create/quotation/new' ]);
        }

        this.loading = false;
      });
  }

  private fromPastShipment() {
    this.pastShip.disable();

    if ( !this.pastShip.get('number').value ) {
      this.loading = false;
      return;
    }
    
    this.pastShip.get('number').setValue( this.pastShip.get('number').value.trim() );
    this.pastShip.get('mode').setValue( this.pastShip.get('mode').value === 'copy' ? null : this.pastShip.get('mode').value );

    this.shipDetailService.load( this.pastShip.get('number').value )
      .subscribe(( shipment ) => {
        if ( shipment ) {
          this.shipmentService.shipment = ShipmentFactory.copy( shipment, this.pastShip.get('mode').value );

          this.router.navigate([ '/create/quotation/new' ]);
        }

        this.loading = false;
      });
  }

  private fromTemplate() {
    const tmplId = this.formGroup.get('templateId');

    tmplId.disable();

    if ( !tmplId.value ) {
      this.loading = false;
      return;
    }
    
    this.templateService.getTemplate( tmplId.value )
      .subscribe(( template ) => {
        if ( template ) {
          this.shipmentService.shipment = template.data;
          this.router.navigate([ '/create/quotation/new' ]);
        }

        this.loading = false;
      });
  }

  buttonDisable() {
    return (this.from.value === 'template' && !this.templateId.value) || (this.from.value === 'past-shipment' && !this.pastShipHawb.value) || (this.from.value === 'past-quotation' && !this.pastQuoteNumber.value);
 }

}
